module.exports = __webpack_public_path__ + "static/img/moaVersionView_pic02.752f443.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moaVersionView/moaVersionView_pic02.png
// module id = 550
// module chunks = 1